console.log('Isotope function loaded');
var Isotope = require('isotope-layout');

let faseAttribute = '';
let fases = document.querySelectorAll('.fases');

console.log(fases);

let newstopicAttribute = '';
let newstopics = document.querySelectorAll('.newstopic');
console.log(newstopics);

// main.js
let galleries = document.querySelectorAll('.mediagallery .row.grid');

if(galleries.count != 0){
    galleries.forEach(gallery => {
        var grid = new Isotope( gallery, {
            itemSelector: '.grid-item',
            percentPosition: true,
            masonry: {
                columnWidth: '.col-12',
            },
        });
    })
}


if(document.querySelector('.portfolio_results')){
    if(fases.length > 0){
        fases[0].classList.add('is-checked');
        
        console.log('portfolio results loaded');
        var grid = new Isotope( '.portfolio_results', {
            itemSelector: '.grid-item',
            layoutMode: 'fitRows'
        });


        fases.forEach(fase => {
            fase.addEventListener('click', () => {

                fases.forEach(faseTwo => {
                    faseTwo.classList.remove('is-checked')
                })

                fase.classList.add('is-checked');

                faseAttribute = fase.getAttribute('data-fase');
                console.log(faseAttribute);

                let faseClass = '.' + faseAttribute;

                console.log(faseClass);

                let resultItems = document.querySelectorAll('.portfolio_results .grid-item');

                // resultItems.forEach(resultItem => {
                //     resultItem.style.display = 'initial';
                // });

                let items = document.querySelectorAll('.portfolio_results .overview_style_04');
                let messagebox = document.querySelector('.messagebox');
                let counter = 0;

                items.forEach(item => {
                    if(item.classList.contains(fase.getAttribute('data-fase'))){
                        console.log('fits');
                        counter = counter +1;
                    }
                })

                console.log(counter);
                if(counter == 0) {
                    setTimeout(messagebox.classList.remove('d-none'), 3000);
                }else {
                    messagebox.classList.add('d-none');
                }
                
                
                grid.arrange({
                    // item element provided as argument
                    filter: faseClass
                });
                
            })
        });
    }
}